import React from 'react';
import { EnterpriseRoutes } from 'src/components/AppRoutes/EnterpriseRoutes';
import { SelfServiceRoutes } from 'src/components/AppRoutes/SelfServiceRoutes';
import { SignUpRoutes } from 'src/components/AppRoutes/SignUpRoutes';

export default function Routes(): JSX.Element {
  return (
    <>
      <EnterpriseRoutes />
      <SelfServiceRoutes />
      <SignUpRoutes />
    </>
  );
}
